export interface WarehouseOptionLike {
  name: string;
  code?: string | null;
  type?: string | null;
}

/** Auto-generated codes from venue sync (e.g. SPOKE-8c3ecae51160) are noise, not identifiers people use. */
const AUTO_GENERATED_CODE = /^(SPOKE|HUB|VENUE)-[0-9a-f]{6,}$/i;

function humanType(type: string): string {
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
}

/**
 * Single display label for warehouse dropdowns: name, plus the code when it's
 * a real human-assigned code, plus the type only when the name/code doesn't
 * already convey it (avoids "Spoke — X (SPOKE-…) · SPOKE").
 */
export function warehouseOptionLabel(warehouse: WarehouseOptionLike): string {
  const parts = [warehouse.name];

  const code = warehouse.code?.trim();
  if (code && !AUTO_GENERATED_CODE.test(code)) {
    parts.push(`(${code})`);
  }

  const type = warehouse.type?.trim();
  if (type) {
    const alreadyMentioned = `${warehouse.name} ${code ?? ''}`
      .toLowerCase()
      .includes(type.toLowerCase());
    if (!alreadyMentioned) {
      parts.push(`· ${humanType(type)}`);
    }
  }

  return parts.join(' ');
}
